import { useState } from 'react'
import dashboardApi from 'services/api/dashboard'

const usePaymentMethodStatus = onChanged => {
  const [statusDialog, setStatusDialog] = useState(null)
  const [statusError, setStatusError] = useState(null)
  const [historyDialog, setHistoryDialog] = useState(null)
  const [savingPaymentAccountId, setSavingPaymentAccountId] = useState(null)

  function openStatusDialog(method) {
    if (savingPaymentAccountId) {
      return
    }

    setStatusError(null)
    setStatusDialog({
      paymentAccountId: method.paymentAccountId,
      isDisabling: !method.isDisabled
    })
  }

  async function confirmStatus(note) {
    if (!statusDialog || savingPaymentAccountId) {
      return
    }

    const { paymentAccountId, isDisabling } = statusDialog
    setSavingPaymentAccountId(paymentAccountId)
    setStatusError(null)

    try {
      await dashboardApi.updatePaymentMethodDisabled({
        paymentAccountId,
        isDisabled: isDisabling,
        note
      })
    } catch (error) {
      setSavingPaymentAccountId(null)
      setStatusError(error.message || 'Payment method could not be updated.')
      return
    }

    setStatusDialog(null)
    try {
      await onChanged()
    } catch (error) {
      setStatusError(error.message || 'Payment methods could not be refreshed.')
    } finally {
      setSavingPaymentAccountId(null)
    }
  }

  async function openHistoryDialog(paymentAccountId) {
    if (historyDialog?.paymentAccountId === paymentAccountId && historyDialog.isLoading) {
      return
    }

    setHistoryDialog({ paymentAccountId, history: [], isLoading: true, error: false })

    try {
      const history = await dashboardApi.getPaymentMethodDisableHistory(paymentAccountId)
      setHistoryDialog(current =>
        current?.paymentAccountId === paymentAccountId
          ? { ...current, history: history || [], isLoading: false }
          : current
      )
    } catch (error) {
      setHistoryDialog(current =>
        current?.paymentAccountId === paymentAccountId
          ? { ...current, isLoading: false, error: true }
          : current
      )
    }
  }

  return {
    closeHistoryDialog: () => setHistoryDialog(null),
    closeStatusDialog: () => setStatusDialog(null),
    confirmStatus,
    historyDialog,
    openHistoryDialog,
    openStatusDialog,
    savingPaymentAccountId,
    statusDialog,
    statusError
  }
}

export default usePaymentMethodStatus
